import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c4464c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "down-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-tishi" }),
    /*#__PURE__*/_createTextVNode(" 文件说明：购买后该文件包含三维图、BOM、二维图、介绍参数四部分文件，即购买之日起可享有30天内不限次数下载 ")
  ])
], -1))
const _hoisted_3 = { class: "info-list" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yuandian" }, null, -1))
const _hoisted_6 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _createTextVNode("【方案图】 "),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.goodsModel), 1)
        ]),
        _createElementVNode("span", {
          class: "down",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.down()))
        }, "下载")
      ])
    ])
  ]))
}